<div class="l-main__contents">
    <div id="wrapper">
        <div class="c-text-1 h-margin-b24">{{ title }}</div>
        <div class="grid-area">
            <div class="loading" *ngIf="loading">
                <app-loading-circle></app-loading-circle>
            </div>
            <div class="wbs-area">
                <is-igx-mapping
                    *ngIf="!loading"
                    [environmentKey]="environmentKey"
                    [frontEndParams]="mappingParams"
                    [frontEndHubParams]="hubParams"
                >
                </is-igx-mapping>
            </div>
        </div>
    </div>
</div>
<app-snackbar #snackbar [autoHide]="true"></app-snackbar>
